import { EditableCallbackParams } from 'ag-grid-community';
import dayjs from 'dayjs';

import { DEFAULT_DATE_PATTERN } from '@/config/common.config';
import { EDITABLE_STATUS_KEYS, EDITABLE_VARIABLE_STATUS_KEYS } from '@/config/statuses.config';
import { ContractLineBillingCycleOutput, VariableContractLineOutput } from '@/graphql/contracts/_generated_/contracts';
import { ContractLineCommonData } from '@/graphql/contracts/_generated_/ContractLineCommonData.fragment';

export const isEditableContractLine = (params: EditableCallbackParams): boolean => {
  const contractLine: ContractLine = params.data;
  return EDITABLE_STATUS_KEYS.includes(contractLine.status.status);
};

export const isEditableBCContractLine = (params: EditableCallbackParams): boolean => {
  const contractLine: ContractLineBillingCycleOutput = params.data;
  return EDITABLE_STATUS_KEYS.includes(contractLine.status?.toString() ?? '');
};

export const isEditableVariableContractLine = (params: EditableCallbackParams): boolean => {
  const contractLine: VariableContractLineOutput = params.data;
  return Boolean(contractLine.status && EDITABLE_VARIABLE_STATUS_KEYS.includes(contractLine.status));
};

export const dateCellRenderer = ({ value }: { value: any }) => {
  // value ?? null - because of this issue https://github.com/iamkun/dayjs/issues/1240
  return dayjs(value ?? null).isValid() ? dayjs(value).format(DEFAULT_DATE_PATTERN) : '';
};

export const getCustomerLabel = 
(customer: 
ContractLineCommonData['shipToCustomer'] | 
ContractLineCommonData['invoiceToCustomer'] | 
undefined | null) => {
  return customer
    // eslint-disable-next-line max-len
    ? `[${customer?.customerAccountNumber}] - ${customer?.customerName}${customer?.postCode ? `, ${customer?.postCode}` : ''}`
    : '';
};

export const getSpreadCustomer = 
(data: 
ContractLineBillingCycleOutput | VariableContractLineOutput, customerPrefix: 'shipToCustomer' | 'invoiceToCustomer'):
ContractLineCommonData['shipToCustomer'] | ContractLineCommonData['invoiceToCustomer'] | undefined | null => {
  return data[`${customerPrefix}Id`] ? {
    __typename: 'CustomerType',
    customerID: data[`${customerPrefix}Id`],
    customerName: data[`${customerPrefix}Name`]!,
    customerAccountNumber: data[`${customerPrefix}AccountNumber`]!,
    address: data[`${customerPrefix}Address`],
    postCode: data[`${customerPrefix}Postcode`],
  } : undefined;
};

export const lastNextDayGap = (data: any) => {
  const lastBillingEndDate = 
    dayjs(data?.lastBillingEndDate ?? null).isValid() ? dayjs(data?.lastBillingEndDate) : null;
  const nextBillingStartDate = 
    dayjs(data?.nextBillingStartDate ?? null).isValid() ? dayjs(data?.nextBillingStartDate) : null;

  if (lastBillingEndDate && nextBillingStartDate) {
    return nextBillingStartDate?.diff(lastBillingEndDate, 'day');
  }
  return -1;
};